import Rest from '@/services/Rest';

export default class SearchService extends Rest {
  static resource = 'search';
}
